const defaultDefaultCustomPacks = '1,2,5*,10,20,25';

export function getDefaultDefaultCustomPacks() {
    return defaultDefaultCustomPacks;
}

export default getDefaultDefaultCustomPacks;
